import { render, staticRenderFns } from "./CrewIndex.vue?vue&type=template&id=a61c9f70&scoped=true&"
import script from "./CrewIndex.vue?vue&type=script&lang=js&"
export * from "./CrewIndex.vue?vue&type=script&lang=js&"
import style0 from "./CrewIndex.vue?vue&type=style&index=0&id=a61c9f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61c9f70",
  null
  
)

export default component.exports